/*
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-10-17 14:32:10
 * @Description: 数据管理表格配置
 * @FilePath: \web\src\components\DataManagement\institutionManagement\tableConfig.js
 */
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '用户名',
    dataIndex: 'username',
    // slots: { customRender: 'username', },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '联系方式',
    dataIndex: 'phone',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '姓名',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
    width: 100,
  },
  {
    title: '单位类型',
    dataIndex: 'orgType',
    slots: { customRender: 'orgType' },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '单位名称',
    dataIndex: 'name',
    slots: { customRender: 'name' },
    ellipsis: true,
    align: 'center',
  },
  // {
  //   title: '行业类型',
  //   dataIndex: 'tradeType',
  //   slots: { customRender: 'tradeType', },
  //   ellipsis: true,
  //   align: 'center',
  // },
  {
    title: '用户权限',
    dataIndex: 'sysRoleList',
    slots: { customRender: 'sysRoleList' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '积分（分）',
    dataIndex: 'integral',
    slots: { customRender: 'integral' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '状态',
    dataIndex: 'status',
    slots: { customRender: 'status' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
  },
];

export default tableConfig;
